import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { NormasTeachingBundleDTO } from "./useNormasTeachingBundleById.ts";

/**
 * Flips the on-sale flag on its own endpoint rather than through the full
 * update, so toggling never round-trips — and never rewrites — the rest of the
 * bundle.
 */
export function useSetNormasTeachingBundleEnabled() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const setNormasTeachingBundleEnabled = async (
    bundleId: string,
    isEnabled: boolean,
  ): Promise<NormasTeachingBundleDTO> => {
    try {
      setLoading(true);
      const { data } =
        await createAxiosInstance().post<NormasTeachingBundleDTO>(
          `/bundles/${bundleId}/enabled`,
          { isEnabled },
        );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { setNormasTeachingBundleEnabled, loading };
}
